import { createSlice } from '@reduxjs/toolkit';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import snackbarUtils from '../../utils/SnackbarUtils';
import { getOrderReportsData } from './orderReport.action';
import {
  OrderReportRow,
  OrderReportsDashboard,
  OrderReportsMeta,
} from '../../types/order/order-reports/order-reports.type';

export type OrderReportsState = {
  items: OrderReportRow[] | null;
  dashboard: OrderReportsDashboard | null;
  meta: OrderReportsMeta | null;
  fetchStatus: FETCH_STATUS;
};

const INITIAL_STATE: OrderReportsState = {
  items: [],
  dashboard: null,
  meta: null,
  fetchStatus: FETCH_STATUS.NULL,
};

export const orderReportsSlice = createSlice({
  name: 'orderReports',
  initialState: INITIAL_STATE,
  reducers: {
    resetOrderReports: () => INITIAL_STATE,
  },
  extraReducers: builder => {
    builder
      .addCase(getOrderReportsData.pending, state => {
        state.fetchStatus = FETCH_STATUS.PENDING;
      })
      .addCase(getOrderReportsData.fulfilled, (state, action) => {
        state.fetchStatus = FETCH_STATUS.FULFILLED;

        state.items = action.payload.items ?? [];
        state.dashboard = action.payload.dashboard;
        state.meta = action.payload.meta;
      })
      .addCase(getOrderReportsData.rejected, (state, action) => {
        state.fetchStatus = FETCH_STATUS.REJECTED;

        state.items = [];
        state.dashboard = null;
        state.meta = null;

        setTimeout(() => {
          snackbarUtils.error((action.payload as string) || 'Failed to generate order report');
        });
      });
  },
});

export const { resetOrderReports } = orderReportsSlice.actions;
export default orderReportsSlice.reducer;
